module.exports = __webpack_public_path__ + "static/media/guia sesion.bd622141.pdf";